import { Component, inject } from '@angular/core';
import { CostCenterService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CostCenterCreateDto,
  CostCenterDto,
  CostCenterExcelDownloadDto,
  CostCenterUpdateDto,
} from '../proxy/controlling/dtos/cost-center';
import { COSTCENTER_CONFIG, COSTCENTER_FIELDS } from './cost-center.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-cost-center',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CostCenterService, ConfirmationService],
  templateUrl: './cost-center.html',
  styleUrl: './cost-center.scss',
})
export class CostCenter extends BaseCrudComponent<
  CostCenterDto,
  CostCenterCreateDto,
  CostCenterUpdateDto,
  CostCenterExcelDownloadDto
> {
  service = inject(CostCenterService);
  config = COSTCENTER_CONFIG;
  fields = COSTCENTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: CostCenterDto): CostCenterUpdateDto {
    return {
      name: data.name,
      sapCode: data.sapCode,
      isVisible: data.isVisible,
      profitCenterId: data.profitCenterId,
      companyCodeId: data.companyCodeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CostCenter';
  }
}
